import styled from 'styled-components';

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	margin-top: 40px;
	justify-content: center;
`;
